import type {TitleBarDetailsModal} from 'src/action-creators/modal';

import * as React from 'react';

import {TitleBarModal} from 'src/components/modals/base-modal';

import WarningIcon from 'src/images/icons/warning-icon.svg?noAttrs';
import {GenericErrorDialogGenesis} from 'src/components/common/reports/genesis-generic-error-dialog';
import css from 'src/components/modals/base-modal.css';


const GenericErrorModal = (props: TitleBarDetailsModal) => {
  if (props.modalVersion === 'genesis') {
    return <GenericErrorDialogGenesis {...props} />;
  }
  return (
    <TitleBarModal
      {...props}
      titleIcon={
        // @ts-expect-error - TS2322 - Type '{ style: { fill: string; }; }' is not assignable to type 'IntrinsicAttributes'.
        props.titleIcon ?? <WarningIcon style={{fill: css.colorWhite}} />
      }
    />
  );
};

export default GenericErrorModal;
